// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@font-face{font-family:\"light\";src:url(\"/fonts/Poppins-Light.ttf\") format(\"truetype\")}@font-face{font-family:\"regular\";src:url(\"/fonts/Poppins-Regular.ttf\") format(\"truetype\")}@font-face{font-family:\"bold\";src:url(\"/fonts/Poppins-SemiBold.ttf\") format(\"truetype\")}.add-bulk{font-size:.85em;margin:30px 0 0 0}", ""]);
// Exports
module.exports = exports;
